<template>
  <div>
    <div class="w-100 d-inline-block app-bg-image position-relative">
      <div class="container autoContent">
        <div class="row margin-top-4 margin-bottom-4">
          <div class="col-xl-5 col-12 col-sm-5 
          col-md-5">
            <div class="w-92 d-inline-block mobile-app-image w-xs-100 w-sm-100 w-md-100 w-ipad-100">
              <!-- <img class="w-100" src="@/assets/images/mobile-app.webp" alt="picture"> -->
              <img class="w-100" v-lazy="require('@/assets/images/mobile-app.png')" alt="picture">
            </div>
          </div>
          <div class="col-xl-7 col-12 col-sm-7 
          col-md-7">
            <div class="w-100 d-inline-block ps-xl-5">
              <p class="margin-bottom-2 text-size-14 fw-bold text-gray text-uppercase family-filson-bold margin-top-4 text-full-14">
                Get us on your hands
              </p>
              <h2 class="half-black fw-bold text-size-22 text-full-24 family-filson-bold w-92 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-2"> 
                Book on the Go with Our Mobile App
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light 
              text-full-13">
                With the Lush Groom mobile app, booking a grooming session for your pet is just a tap away
              </p>
            </div>
            <div class="w-100 d-inline-block app-play-image mb-xl-0 mb-2">
              <p class="family-inter-light text-full-14 text-size-14 fw-bold margin-top-4 margin-bottom-2 text-black">Download The App</p>
              <a class="d-inline-block" href="javascript:void(0)">
                <img v-lazy="require('@/assets/images/google-play-image.svg')" alt="picture">
              </a>
              <a class="d-inline-block ms-3" href="javascript:void(0)">
                <img v-lazy="require('@/assets/images/app-store-image.svg')" alt="picture">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mobileAppComponent',
}
</script>

<style scoped>

</style>
